import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFlashcards: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="flashcards, cards, pages"><path d="M10.625 7.17745L11.0641 3L21.0093 4.04528L19.6504 16.9741L14.0021 16.3804" stroke="currentColor" strokeWidth="1.5"/><path d="M2.95312 8.04528L12.8983 7L14.2572 19.9288L4.312 20.9741L2.95312 8.04528Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconFlashcards;
